import React from "react";
import { useTranslation } from "react-i18next";
import WorkProcessCard from "./WorkProcessCard";

const WorkProcessTwo = () => {
  const { t } = useTranslation();
  const workProcess = t("work-process", { returnObjects: true });
  return (
    <>
      {/*==================== Work Process Two start ====================*/}
      <div className="work-process-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">{t("work-process-title")}</h6>
            <div
              dangerouslySetInnerHTML={{ __html: t("work-process-slogan") }}
            ></div>
          </div>
          <div className="row">
            {workProcess.map((process, index) => (
              <WorkProcessCard
                key={index}
                id={process.id}
                title={process.title}
                description={process.description}
                icon={process.icon}
              />
            ))}
          </div>
        </div>
      </div>
      {/* ==================== Work Process Two end ====================*/}
    </>
  );
};

export default WorkProcessTwo;
